// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grid\" width=\"10\" height=\"10\" patternUnits=\"userSpaceOnUse\"><path d=\"M 10 0 L 0 0 0 10\" fill=\"none\" stroke=\"%23ffffff\" stroke-width=\"0.5\" opacity=\"0.1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url%28%23grid%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login page – centered layout */
.login-container-centered {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem;
  position: relative;
}

.login-container-centered::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  z-index: 0;
}

.login-form-panel-centered {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 440px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-form-wrapper {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 440px;
  animation: loginFadeInUp 0.6s ease-out;
}

@keyframes loginFadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-form {
  background: #ffffff;
  padding: 3rem;
  border-radius: 20px;
  box-shadow:
    0 25px 50px -12px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(226, 232, 240, 0.8);
  position: relative;
}

.login-form::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899);
  border-radius: 20px 20px 0 0;
}

.login-title {
  font-size: 2.25rem;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 0.5rem;
  text-align: center;
  letter-spacing: -0.03em;
  line-height: 1.2;
}

.login-subtitle {
  font-size: 1rem;
  color: #64748b;
  text-align: center;
  margin-bottom: 2.5rem;
  font-weight: 400;
}

.form-group {
  margin-bottom: 1.5rem;
}

.label2 {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
  letter-spacing: 0.01em;
}

.login-form .form-control {
  width: 100%;
  padding: 0.875rem 1.125rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  background: #ffffff;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  color: #1e293b;
  line-height: 1.5;
}

.login-form .form-control:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  background: #ffffff;
}

.login-form .form-control::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

.password-container {
  position: relative;
}

.eye-icon-container {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 6px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.eye-icon-container:hover {
  background: #f1f5f9;
}

.eye3 {
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.eye-icon-container:hover .eye3 {
  opacity: 1;
}

.login-button {
  width: 100%;
  padding: 1rem 1.5rem;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: 1rem;
  position: relative;
  overflow: hidden;
}

.login-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  transform: translateY(-1px);
  box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);
}

.login-button:active {
  transform: translateY(0);
}

.login-button:disabled {
  background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.login-button.loading {
  background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
  animation: loginLoadingPulse 1.5s ease-in-out infinite;
}

@keyframes loginLoadingPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.8; }
}

.login-button:focus-visible,
.login-form .form-control:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

@media (max-width: 768px) {
  .login-container-centered {
    padding: 1rem;
  }
  .login-form-panel-centered {
    max-width: 100%;
  }
  .login-form {
    padding: 2rem 1.5rem;
    border-radius: 16px;
  }
  .login-title {
    font-size: 1.875rem;
  }
}

@media (max-width: 480px) {
  .login-container-centered {
    padding: 0.5rem;
  }
  .login-form {
    padding: 1.5rem 1rem;
    border-radius: 12px;
  }
  .login-title {
    font-size: 1.75rem;
  }
}

/* Reset password modal */
.login-reset-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(6px);
}

.login-reset-modal {
  position: relative;
  width: 100%;
  max-width: 460px;
  background: #ffffff;
  padding: 2.25rem 2.5rem 2rem;
  border-radius: 20px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  box-shadow:
    0 25px 50px -12px rgba(0, 0, 0, 0.25),
    0 0 0 1px rgba(0, 0, 0, 0.04);
  animation: loginFadeInUp 0.3s ease-out;
  overflow: hidden;
}

.login-reset-modal::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899);
}

.login-reset-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.login-reset-close:hover:not(:disabled) {
  background: #f1f5f9;
  color: #475569;
}

.login-reset-close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.login-reset-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin: 0 auto 1.25rem;
  border-radius: 14px;
  background: linear-gradient(135deg, #eff6ff 0%, #ede9fe 100%);
  color: #3b82f6;
}

.login-reset-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.5rem;
  text-align: center;
  letter-spacing: -0.02em;
}

.login-reset-subtitle {
  font-size: 0.9375rem;
  color: #64748b;
  text-align: center;
  margin: 0 0 1.75rem;
  line-height: 1.55;
  padding: 0 0.25rem;
}

.login-reset-form {
  text-align: left;
}

.login-reset-field {
  margin-bottom: 1.25rem;
}

.login-reset-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
  letter-spacing: 0.01em;
}

.login-reset-password-wrap {
  position: relative;
}

.login-reset-input {
  width: 100%;
  box-sizing: border-box;
  padding: 0.875rem 2.75rem 0.875rem 1.125rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  background: #ffffff;
  color: #1e293b;
  line-height: 1.5;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.login-reset-input::placeholder {
  color: #94a3b8;
}

.login-reset-input:hover {
  border-color: #cbd5e1;
}

.login-reset-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.login-reset-eye {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.login-reset-eye:hover {
  background: #f1f5f9;
  color: #475569;
}

.login-reset-actions {
  display: flex;
  gap: 12px;
  margin-top: 1.75rem;
}

.login-reset-cancel-btn {
  flex: 1 1;
  padding: 0.9375rem 1.25rem;
  border: 2px solid #cbd5e1;
  border-radius: 12px;
  background: #ffffff;
  color: #334155;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.login-reset-cancel-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #94a3b8;
}

.login-reset-cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.login-reset-submit-btn {
  flex: 1.35 1;
  padding: 0.9375rem 1.25rem;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: #ffffff;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.login-reset-submit-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  transform: translateY(-1px);
  box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);
}

.login-reset-submit-btn:active:not(:disabled) {
  transform: translateY(0);
}

.login-reset-submit-btn:disabled,
.login-reset-submit-btn.loading {
  background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

@media (max-width: 480px) {
  .login-reset-modal {
    padding: 2rem 1.25rem 1.5rem;
    border-radius: 16px;
  }

  .login-reset-actions {
    flex-direction: column-reverse;
  }

  .login-reset-cancel-btn,
  .login-reset-submit-btn {
    flex: none;
    width: 100%;
  }
}

/* ===== Dark theme overrides (gradient backdrop kept; card darkened) ===== */
[data-theme="dark"] .login-form,
[data-theme="dark"] .login-reset-modal {
  background: var(--surface);
  border-color: var(--border);
}
[data-theme="dark"] .login-title,
[data-theme="dark"] .login-reset-title {
  color: var(--text-strong);
}
[data-theme="dark"] .login-subtitle,
[data-theme="dark"] .login-reset-subtitle {
  color: var(--text-muted);
}
[data-theme="dark"] .label2,
[data-theme="dark"] .login-reset-label {
  color: var(--text);
}
[data-theme="dark"] .login-form .form-control,
[data-theme="dark"] .login-reset-input {
  background: var(--surface-2);
  border-color: var(--border);
  color: var(--text);
}
[data-theme="dark"] .login-form .form-control:focus,
[data-theme="dark"] .login-reset-input:focus {
  background: var(--surface-2);
  border-color: var(--primary);
}
[data-theme="dark"] .eye-icon-container:hover,
[data-theme="dark"] .login-reset-eye:hover,
[data-theme="dark"] .login-reset-close:hover:not(:disabled) {
  background: var(--surface-3);
  color: var(--text);
}
[data-theme="dark"] .login-reset-cancel-btn {
  background: var(--surface-2);
  border-color: var(--border-strong);
  color: var(--text);
}
[data-theme="dark"] .login-reset-cancel-btn:hover:not(:disabled) {
  background: var(--surface-3);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/index.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAA0V;EAC1V,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB;;iCAE+B;EAC/B,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,iDAAiD;EACjD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,sDAAsD;AACxD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,0CAA0C;EAC1C;;iCAE+B;EAC/B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,2CAA2C;EAC3C,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAU;EACV,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,UAAU;IACV,WAAW;EACb;AACF;;AAEA,6EAA6E;AAC7E;;EAEE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;;EAEE,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;;;EAGE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B","sourcesContent":["/* Login page – centered layout */\n.login-container-centered {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 2rem;\n  position: relative;\n}\n\n.login-container-centered::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grid\" width=\"10\" height=\"10\" patternUnits=\"userSpaceOnUse\"><path d=\"M 10 0 L 0 0 0 10\" fill=\"none\" stroke=\"%23ffffff\" stroke-width=\"0.5\" opacity=\"0.1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grid)\"/></svg>');\n  z-index: 0;\n}\n\n.login-form-panel-centered {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 440px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-form-wrapper {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 440px;\n  animation: loginFadeInUp 0.6s ease-out;\n}\n\n@keyframes loginFadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.login-form {\n  background: #ffffff;\n  padding: 3rem;\n  border-radius: 20px;\n  box-shadow:\n    0 25px 50px -12px rgba(0, 0, 0, 0.08),\n    0 0 0 1px rgba(0, 0, 0, 0.02);\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  position: relative;\n}\n\n.login-form::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899);\n  border-radius: 20px 20px 0 0;\n}\n\n.login-title {\n  font-size: 2.25rem;\n  font-weight: 800;\n  color: #0f172a;\n  margin-bottom: 0.5rem;\n  text-align: center;\n  letter-spacing: -0.03em;\n  line-height: 1.2;\n}\n\n.login-subtitle {\n  font-size: 1rem;\n  color: #64748b;\n  text-align: center;\n  margin-bottom: 2.5rem;\n  font-weight: 400;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.label2 {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.5rem;\n  letter-spacing: 0.01em;\n}\n\n.login-form .form-control {\n  width: 100%;\n  padding: 0.875rem 1.125rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  background: #ffffff;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  color: #1e293b;\n  line-height: 1.5;\n}\n\n.login-form .form-control:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  background: #ffffff;\n}\n\n.login-form .form-control::placeholder {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.password-container {\n  position: relative;\n}\n\n.eye-icon-container {\n  position: absolute;\n  right: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.eye-icon-container:hover {\n  background: #f1f5f9;\n}\n\n.eye3 {\n  opacity: 0.6;\n  transition: opacity 0.2s ease;\n}\n\n.eye-icon-container:hover .eye3 {\n  opacity: 1;\n}\n\n.login-button {\n  width: 100%;\n  padding: 1rem 1.5rem;\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  margin-top: 1rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.login-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);\n}\n\n.login-button:active {\n  transform: translateY(0);\n}\n\n.login-button:disabled {\n  background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.login-button.loading {\n  background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);\n  animation: loginLoadingPulse 1.5s ease-in-out infinite;\n}\n\n@keyframes loginLoadingPulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.8; }\n}\n\n.login-button:focus-visible,\n.login-form .form-control:focus-visible {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n@media (max-width: 768px) {\n  .login-container-centered {\n    padding: 1rem;\n  }\n  .login-form-panel-centered {\n    max-width: 100%;\n  }\n  .login-form {\n    padding: 2rem 1.5rem;\n    border-radius: 16px;\n  }\n  .login-title {\n    font-size: 1.875rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-container-centered {\n    padding: 0.5rem;\n  }\n  .login-form {\n    padding: 1.5rem 1rem;\n    border-radius: 12px;\n  }\n  .login-title {\n    font-size: 1.75rem;\n  }\n}\n\n/* Reset password modal */\n.login-reset-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  background: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n.login-reset-modal {\n  position: relative;\n  width: 100%;\n  max-width: 460px;\n  background: #ffffff;\n  padding: 2.25rem 2.5rem 2rem;\n  border-radius: 20px;\n  border: 1px solid rgba(226, 232, 240, 0.9);\n  box-shadow:\n    0 25px 50px -12px rgba(0, 0, 0, 0.25),\n    0 0 0 1px rgba(0, 0, 0, 0.04);\n  animation: loginFadeInUp 0.3s ease-out;\n  overflow: hidden;\n}\n\n.login-reset-modal::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899);\n}\n\n.login-reset-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.login-reset-close:hover:not(:disabled) {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.login-reset-close:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.login-reset-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  margin: 0 auto 1.25rem;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #eff6ff 0%, #ede9fe 100%);\n  color: #3b82f6;\n}\n\n.login-reset-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 0.5rem;\n  text-align: center;\n  letter-spacing: -0.02em;\n}\n\n.login-reset-subtitle {\n  font-size: 0.9375rem;\n  color: #64748b;\n  text-align: center;\n  margin: 0 0 1.75rem;\n  line-height: 1.55;\n  padding: 0 0.25rem;\n}\n\n.login-reset-form {\n  text-align: left;\n}\n\n.login-reset-field {\n  margin-bottom: 1.25rem;\n}\n\n.login-reset-label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.5rem;\n  letter-spacing: 0.01em;\n}\n\n.login-reset-password-wrap {\n  position: relative;\n}\n\n.login-reset-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.875rem 2.75rem 0.875rem 1.125rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  background: #ffffff;\n  color: #1e293b;\n  line-height: 1.5;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.login-reset-input::placeholder {\n  color: #94a3b8;\n}\n\n.login-reset-input:hover {\n  border-color: #cbd5e1;\n}\n\n.login-reset-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);\n}\n\n.login-reset-eye {\n  position: absolute;\n  right: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.login-reset-eye:hover {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.login-reset-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 1.75rem;\n}\n\n.login-reset-cancel-btn {\n  flex: 1;\n  padding: 0.9375rem 1.25rem;\n  border: 2px solid #cbd5e1;\n  border-radius: 12px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.login-reset-cancel-btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #94a3b8;\n}\n\n.login-reset-cancel-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.login-reset-submit-btn {\n  flex: 1.35;\n  padding: 0.9375rem 1.25rem;\n  border: none;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: #ffffff;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.login-reset-submit-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);\n}\n\n.login-reset-submit-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.login-reset-submit-btn:disabled,\n.login-reset-submit-btn.loading {\n  background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n@media (max-width: 480px) {\n  .login-reset-modal {\n    padding: 2rem 1.25rem 1.5rem;\n    border-radius: 16px;\n  }\n\n  .login-reset-actions {\n    flex-direction: column-reverse;\n  }\n\n  .login-reset-cancel-btn,\n  .login-reset-submit-btn {\n    flex: none;\n    width: 100%;\n  }\n}\n\n/* ===== Dark theme overrides (gradient backdrop kept; card darkened) ===== */\n[data-theme=\"dark\"] .login-form,\n[data-theme=\"dark\"] .login-reset-modal {\n  background: var(--surface);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .login-title,\n[data-theme=\"dark\"] .login-reset-title {\n  color: var(--text-strong);\n}\n[data-theme=\"dark\"] .login-subtitle,\n[data-theme=\"dark\"] .login-reset-subtitle {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .label2,\n[data-theme=\"dark\"] .login-reset-label {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .login-form .form-control,\n[data-theme=\"dark\"] .login-reset-input {\n  background: var(--surface-2);\n  border-color: var(--border);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .login-form .form-control:focus,\n[data-theme=\"dark\"] .login-reset-input:focus {\n  background: var(--surface-2);\n  border-color: var(--primary);\n}\n[data-theme=\"dark\"] .eye-icon-container:hover,\n[data-theme=\"dark\"] .login-reset-eye:hover,\n[data-theme=\"dark\"] .login-reset-close:hover:not(:disabled) {\n  background: var(--surface-3);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .login-reset-cancel-btn {\n  background: var(--surface-2);\n  border-color: var(--border-strong);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .login-reset-cancel-btn:hover:not(:disabled) {\n  background: var(--surface-3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
